import Logo from '../Logo/Logo';
import UserMenu from '../UserMenu/UserMenu';
import ClassSelector from '../../ClassSelector';

const Header: React.FC = () => {
  return (
    <div className="relative z-20">
      <div className="absolute inset-0 animate-gradient bg-[length:400%_400%] bg-gradient-to-br from-lime-400 via-emerald-500 to-green-600 opacity-90" />
      <header className="relative z-30 backdrop-blur-sm border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-6">
              <Logo />
              <ClassSelector />
            </div>
            <UserMenu />
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header; 